import { render, staticRenderFns } from "./AssessmentFormEditor.vue?vue&type=template&id=ec0ad8b0&scoped=true"
import script from "./AssessmentFormEditor.vue?vue&type=script&lang=js"
export * from "./AssessmentFormEditor.vue?vue&type=script&lang=js"
import style0 from "./AssessmentFormEditor.vue?vue&type=style&index=0&id=ec0ad8b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0ad8b0",
  null
  
)

export default component.exports